import { render, staticRenderFns } from "./CaseDataInfo.vue?vue&type=template&id=7c8796eb&scoped=true&"
import script from "./CaseDataInfo.vue?vue&type=script&lang=js&"
export * from "./CaseDataInfo.vue?vue&type=script&lang=js&"
import style0 from "./CaseDataInfo.vue?vue&type=style&index=0&id=7c8796eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8796eb",
  null
  
)

export default component.exports